import { useMemo, useState, useEffect } from "react";

export function StarWarsAnimation() {
	const [starWarsText, setStarWarsText] = useState<string | null>(null);

	useEffect(() => {
		fetch("/text/starWarsCrawlText.txt").then((res) =>
			res.text().then((text) => {
				setStarWarsText(text);
			}),
		);
	}, []);

	const chunks = useMemo(() => {
		if (!starWarsText) {
			return [];
		}

		const starWarsLines = starWarsText.split("\n");
		const chunks: string[][] = [];

		const chunkSize = 14;

		for (let i = 0; i < starWarsLines.length; i += chunkSize) {
			const chunk = starWarsLines.slice(i, i + chunkSize);
			chunks.push(chunk);
		}
		return chunks;
	}, [starWarsText]);

	const [index, setIndex] = useState(0);

	useEffect(() => {
		if (chunks.length === 0) {
			return;
		}

		const delay = Number.parseInt(chunks[index][0]) * 67;
		if (index < chunks.length) {
			setTimeout(() => {
				setIndex(() => index + 1);
			}, delay);
		}
	}, [chunks, index]);

	if (chunks.length === 0) {
		return null;
	}

	return (
		<pre style={{ height: 200, fontSize: 16, lineHeight: "16px" }}>
			<code>{chunks[index].slice(1).join("\n")}</code>
		</pre>
	);
}
